import React from 'react';
import './PresaleAgreement.css';

const PresaleAgreement = () => {
  return (
    <div className="presale-agreement-container">
      <section className="content-container container my-4">
        <h1 className="text-center mb-4">ABAY Token Utility Access Agreement</h1>

        <h2>NOTICE</h2>
        <p>
          <strong>NOTICE:</strong> This document is not an investment solicitation and does not constitute an offer of securities, commodities, or financial instruments of any kind. It does not require registration or approval from any regulatory authority in any jurisdiction. ABAY Tokens are <strong>utility tokens</strong> designed solely to enable access to the ABAY Platform’s payment and service features. They carry <strong>no ownership, profit-sharing, or equity rights</strong> of any kind and are <strong>not issued for investment or speculation purposes.</strong>
        </p>

        <h2>PARTIES</h2>
        <p>This Utility Token Access Agreement (the "Agreement") is entered into as of the date of acceptance between:</p>
        <ol>
          <li><strong>HDC</strong> (the "Company"), operator of the abaytoken.com Platform; and</li>
          <li>Any individual or legal entity (the "Participant") acquiring ABAY Tokens for the purpose of using them within the ABAY ecosystem.</li>
        </ol>
        <p>The Company and Participant are each a "Party" and collectively the "Parties."</p>

        <h2>PREAMBLE</h2>
        <p><strong>WHEREAS:</strong></p>
        <ul>
          <li>The Company operates the <strong>ABAY Platform</strong>, a decentralized blockchain-based payment and utility ecosystem where ABAY Tokens are used for transactions, access to digital services, and fee reductions.</li>
          <li>The Company offers ABAY Tokens to Participants to facilitate immediate and future use within the Platform, not as an investment vehicle.</li>
          <li>The Platform is active and will continuously expand with additional utility features as described on <a href="https://www.abaytoken.com" target="_blank" rel="noopener noreferrer">abaytoken.com</a>.</li>
          <li>Participation is voluntary, restricted to non-Prohibited Participants, and limited to accepted cryptocurrencies (e.g., USDC, USDT on Solana).</li>
          <li>ABAY Tokens provide <strong>consumptive use only</strong> and are not intended or marketed for profit expectation or resale for speculative gain.</li>
        </ul>

        <p><strong>NOW, THEREFORE,</strong> the Parties agree as follows:</p>

        <h2>1. Definitions</h2>
        <ul>
          <li><strong>ABAY Token:</strong> A functional, blockchain-based utility token enabling access, payment, or rewards within the ABAY Platform.</li>
          <li><strong>Platform:</strong> The decentralized payment and services system powered by ABAY Tokens.</li>
          <li><strong>Dissolution Event:</strong> An event necessitating the Company’s dissolution or liquidation.</li>
          <li><strong>Accepted Currencies:</strong> USDC and USDT on the Solana network, unless otherwise announced.</li>
          <li><strong>Participant:</strong> A user acquiring ABAY Tokens for utility purposes within the Platform.</li>
          <li><strong>Prohibited Participant:</strong> Individuals or entities from jurisdictions where token sales or ownership are restricted (e.g., the United States) or acting on their behalf.</li>
          <li><strong>Utility Use:</strong> The right to spend ABAY Tokens on Platform transactions, service access, rewards, and transaction fee discounts.</li>
          <li><strong>Wallet:</strong> A Solana-based digital wallet capable of holding ABAY Tokens and interacting with Platform smart contracts.</li>
        </ul>

        <h2>2. Participation and Token Allocation</h2>
        <h3>2.1 Process</h3>
        <p>Participants may acquire ABAY Tokens through the Platform interface or authorized distribution channels. All acquisitions are final and non-refundable, except as expressly required by applicable law or this Agreement.</p>

        <h3>2.2 Token Delivery and Use</h3>
        <p>
          Tokens are delivered to the Participant’s Wallet upon confirmation of payment and are immediately usable for consumptive functions on the Platform, such as making payments, accessing services, or earning usage-based discounts and benefits.
        </p>

        <h3>2.3 Non-Compliance</h3>
        <p>
          If eligibility requirements are not met, the Company may cancel participation and, at its discretion, refund the contribution after applicable verification steps.
        </p>

        <h2>3. Participation Terms</h2>
        <h3>3.1 Eligibility</h3>
        <p>
          Participation is open only to non-Prohibited Participants who comply with local laws. U.S. persons and residents are strictly prohibited from participating.
        </p>

        <h3>3.2 No Investment Intent</h3>
        <p>
          Participants acknowledge that ABAY Tokens are obtained solely for personal use within the Platform and not for investment, speculation, or resale for profit.
        </p>

        <h3>3.3 Token Nature</h3>
        <p>
          ABAY Tokens are <strong>utility tokens</strong>. They confer no ownership, voting rights, dividends, profit participation, or liquidation preference. Their purpose is limited to accessing and using Platform services.
        </p>

        <h3>3.4 Intellectual Property</h3>
        <p>
          The Company retains all intellectual property rights in the Platform and ABAY Token. Token ownership does not grant any license or rights in Company IP.
        </p>

        <h3>3.5 Relationship</h3>
        <p>
          Participation does not create any partnership, employment, joint venture, or agency relationship between the Participant and the Company.
        </p>

        <h2>4. Dissolution Event</h2>
        <h3>4.1 Refund</h3>
        <p>
          If a Dissolution Event occurs prior to completion of distribution, the Company may refund Participants their contributions, subject to applicable UAE law.
        </p>

        <h2>5. Termination</h2>
        <p>
          This Agreement terminates upon token delivery and completion of the Participant’s purchase. Clauses related to disclaimers, liability, and indemnity survive termination.
        </p>

        <h2>6. Company Representations</h2>
        <p>
          The Company represents that it is duly organized, authorized to operate the Platform, and that its execution of this Agreement does not violate any law or contractual obligation.
        </p>

        <h2>7. Participant Representations</h2>
        <p>The Participant represents and warrants that:</p>
        <ul>
          <li>They are acquiring ABAY Tokens for use on the Platform only;</li>
          <li>They are not a U.S. person or acquiring on behalf of one;</li>
          <li>They understand that the Token is not an investment or financial instrument;</li>
          <li>They are financially and technically able to use blockchain-based systems;</li>
          <li>They have reviewed and understood the risks disclosed herein; and</li>
          <li>They are responsible for all applicable taxes related to Token use.</li>
        </ul>

        <h2>8. Taxes & Indemnity</h2>
        <p>
          Participants are responsible for any taxes related to the acquisition or use of ABAY Tokens and agree to indemnify the Company from related claims or liabilities.
        </p>

        <h2>9. Disclaimers & Liability</h2>
        <p>
          ABAY Tokens and the Platform are provided “as is.” The Company disclaims all warranties, express or implied. Participants assume all risks associated with blockchain technology, token loss, volatility, or system failure.
        </p>

        <h2>10. Risks</h2>
        <p>Participation in a blockchain-based ecosystem carries risks, including but not limited to:</p>
        <ul>
          <li>Technology or smart contract vulnerabilities;</li>
          <li>Market fluctuations or lack of liquidity;</li>
          <li>Loss of access keys or wallets;</li>
          <li>Platform updates or service discontinuation;</li>
          <li>Legal or regulatory changes affecting token use;</li>
          <li>Operational or cybersecurity issues.</li>
        </ul>
        <p>Participants acknowledge and accept all such risks.</p>

        <h2>11. Miscellaneous</h2>
        <h3>11.1 Discharge</h3>
        <p>Delivery of tokens to the Participant’s Wallet fulfills the Company’s obligations under this Agreement.</p>

        <h3>11.2 Assignment</h3>
        <p>Participants may not assign rights or obligations without the Company’s written consent.</p>

        <h3>11.3 Notices</h3>
        <p>All notices must be in writing and delivered electronically via official Company channels.</p>

        <h3>11.4 Amendments</h3>
        <p>This Agreement may be amended only by mutual written consent of the Parties.</p>

        <h3>11.5 Governing Law</h3>
        <p>This Agreement is governed by and construed under the laws of the United Arab Emirates. All disputes are subject to the jurisdiction of UAE courts.</p>

        <h3>11.6 Entire Agreement</h3>
        <p>This document represents the entire understanding between the Parties and supersedes all prior agreements regarding ABAY Tokens.</p>

        <h2>Annex I: Participant Representations</h2>
        <p>Participants confirm that they:</p>
        <ul>
          <li>Own the Wallet used for token receipt;</li>
          <li>Are not a Prohibited Participant or politically exposed person;</li>
          <li>Are not under bankruptcy, criminal conviction, or investigation;</li>
          <li>Provide funds from legitimate and verifiable sources;</li>
          <li>Understand token use is limited to the ABAY Platform.</li>
        </ul>
      </section>
    </div>
  );
};

export default PresaleAgreement;
